/* Component used on the top of all pages to 
   display that page's title and other information */
import React from "react";
import door from "../assets/door.png";
import styles from "../styles/TopBox.module.css";
import { Col, Row, Image } from "react-bootstrap";

function TopBox(props) {
    const {title, scene, title2, title3, title4, work} = props; 
    return (
        <div className={styles.RegBox}>
        <Row className={styles.Row}>
        <Col xs={{ span: 1, offset: 1 }} lg={{ span: 1, offset: 3 }}
            md={{ span: 1, offset: 2 }}
            className={`text-center ${styles.Longboxl}`}>    
        <p>F</p> 
        <p>I</p>
        <p>R</p>
        <p>S</p>
        <p>T</p> 
        </Col>

        <Col className="pb-1" xs={8} md={6} lg={4}>
            <div className={`${styles.Titlebox}`}>
            <Row className="py-0 my-0">
                <Col xs={1} className="py-0 my-0">
                    <Image
                        className={styles.SmallPanel}
                        src={door}
                        alt="door"
                        // height="120"
                    />
                </Col>
                <Col xs={10} 
                className={`d-flex align-items-center justify-content-center ${styles.Alignme}`} >
                    <div >
                    <h1 className={` text-center ${styles.TitleT}`}>FIRSTSLATE</h1>
                    {work && <h2 className={` text-center ${styles.Title}`}>{work} </h2>}
                    {title && <h2 className={` text-center ${styles.Title2}`}>{title} </h2>}
                    {title4 && <h2 className={` text-center ${styles.Title2}`}>{title4} </h2>}
                    {scene && <h2 className={` text-center ${styles.Title2}`}>Scene {scene} </h2>}
                    <h5 style={{ textTransform: 'capitalize'}} className={`text-center ${styles.Title3}`}>{title2} {title3}</h5>
                    </div>
                </Col>
            </Row>
            </div>
            </Col>
        <Col xs={{ span: 1, offset: 0 }} lg={{ span: 1, offset: 1 }}
            md={{ span: 1, offset: 0 }}
            className={`text-center px-0 mx-0 ${styles.Longboxr}`}
        >    
        <p>S</p> 
        <p>L</p>
        <p>A</p>
        <p>T</p> 
        <p>E</p>
        </Col>
        {/* <Col xs={2}
            className={`text-center mt-5 ${styles.Longboxr}`}
        >    
        <p className="mt-4">C A L L E R</p>
        </Col> */}
    </Row>
    </div>
    )
}

export default TopBox